import { ReportType } from 'src/graphql';
import { SubmissionModeForDisplay } from 'src/types';

const submissionModeIdTextMap = {
  1: SubmissionModeForDisplay.GO_TOGETHER,
  2: SubmissionModeForDisplay.GO_AHEAD,
  3: SubmissionModeForDisplay.GO_ANONYMOUS,
  4: SubmissionModeForDisplay.OPEN_REPORTING,
  5: SubmissionModeForDisplay.MANUAL_INTAKE,
  6: SubmissionModeForDisplay.VAULT_TALK,
  7: SubmissionModeForDisplay.SLACK_GO_AHEAD,
  8: SubmissionModeForDisplay.SLACK_GO_ANONYMOUS,
  9: SubmissionModeForDisplay.BULK_IMPORT,
  10: SubmissionModeForDisplay.COI,
  11: SubmissionModeForDisplay.REPORTER_PORTAL,
  12: SubmissionModeForDisplay.REPORTER_PORTAL_GO_TOGETHER,
};

export const mapSubmissionModeToRoute = (report: ReportType) => {
  const { submissionMode } = report;

  switch (submissionMode) {
    case 1:
    case 2:
    case 3:
      return submissionModeIdTextMap[submissionMode];
    case 4:
      if (
        (!report.Reporter?.name && !report.Reporter?.email) ||
        report.anonymous
      ) {
        return `${SubmissionModeForDisplay.OPEN_REPORTING} - Anonymous`;
      }
      return SubmissionModeForDisplay.OPEN_REPORTING;
    case 5:
      if (
        (!report.Reporter?.name && !report.Reporter?.email) ||
        report.anonymous
      ) {
        return `${SubmissionModeForDisplay.MANUAL_INTAKE} - Anonymous`;
      }
      return SubmissionModeForDisplay.MANUAL_INTAKE;
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
      return submissionModeIdTextMap[submissionMode];
    default:
      return SubmissionModeForDisplay.UNKNOWN;
  }
};
